import SEOHeader from "../components/SEOHeader";
import Content from "../i18n/de";
import SectionHelper from "../components/SectionHelper";
import styled from "styled-components";

const Container = styled.div`
  h1 {
    font-size: 40px;
    margin-bottom: 20px;
  }
  h5 {
    margin-top: 20px;
  }
  ul {
    li {
      color: #000;
    }
  }
  p {
    margin-top: 5px;
    color: #000;
  }
`;

function Impressum() {
  return (
    <>
      <SEOHeader {...Content.meta.impressum} />
      <SectionHelper>
        <Container>
          <h1>Impressum</h1>
          <h5>Angaben gem&auml;&szlig; &sect; 5 TMG</h5>
          <p>
            WProduction GbR
            <br />
            Dreihalde 10
            <br />
            73527 Schw&auml;bisch Gm&uuml;nd
          </p>
          <p>
            <strong>Vertreten durch:</strong>
            <br />
            Wiens Vadim
            <br />
            Wall Viktor
          </p>
          <h5>Kontakt</h5>
          <p>
            Telefon: 0170 386 05 13
            <br />
            E-Mail: info@wproduction.de
          </p>
          <h5>Design und technische Umsetzung</h5>
          <p>
            Die grafische Gestaltung und technische Umsetzung dieser Webseite
            wurde von der Peakconcepts GmbH realisiert.
            <br></br>Für den Inhalt bleibt der Herausgeber dieser Webseite
            verantwortlich.
          </p>
          <p>
            Webseite: <a href="https://www.peakconcepts.de/">peakconcepts.de</a>
          </p>
          <h5>Angaben zur Berufshaftpflichtversicherung</h5>
          <p>
            <strong>Name und Sitz des Versicherers:</strong>
            <br />
            Allianz Versicherung
            <br />
            R&uuml;diger Steeb Generalvertretung
            <br />
            Banhofstra&szlig;e 4<br />
            73563 M&ouml;gglingen
          </p>
          <p>
            <strong>Geltungsraum der Versicherung:</strong>
            <br />
            Europaweit
          </p>
          <h5>
            Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle
          </h5>
          <p>
            Wir sind nicht bereit oder verpflichtet, an
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen.
          </p>
          <h5>Haftung f&uuml;r Inhalte</h5>{" "}
          <p>
            Als Diensteanbieter sind wir gem&auml;&szlig; &sect; 7 Abs.1 TMG
            f&uuml;r eigene Inhalte auf diesen Seiten nach den allgemeinen
            Gesetzen verantwortlich. Nach &sect;&sect; 8 bis 10 TMG sind wir als
            Diensteanbieter jedoch nicht verpflichtet, &uuml;bermittelte oder
            gespeicherte fremde Informationen zu &uuml;berwachen oder nach
            Umst&auml;nden zu forschen, die auf eine rechtswidrige
            T&auml;tigkeit hinweisen.
          </p>{" "}
          <p>
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
            Informationen nach den allgemeinen Gesetzen bleiben hiervon
            unber&uuml;hrt. Eine diesbez&uuml;gliche Haftung ist jedoch erst ab
            dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
            m&ouml;glich. Bei Bekanntwerden von entsprechenden
            Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
          </p>{" "}
          <h5>Haftung f&uuml;r Links</h5>{" "}
          <p>
            Unser Angebot enth&auml;lt Links zu externen Websites Dritter, auf
            deren Inhalte wir keinen Einfluss haben. Deshalb k&ouml;nnen wir
            f&uuml;r diese fremden Inhalte auch keine Gew&auml;hr
            &uuml;bernehmen. F&uuml;r die Inhalte der verlinkten Seiten ist
            stets der jeweilige Anbieter oder Betreiber der Seiten
            verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
            Verlinkung auf m&ouml;gliche Rechtsverst&ouml;&szlig;e
            &uuml;berpr&uuml;ft. Rechtswidrige Inhalte waren zum Zeitpunkt der
            Verlinkung nicht erkennbar.
          </p>{" "}
          <p>
            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist
            jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
            zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir
            derartige Links umgehend entfernen.
          </p>{" "}
          <h5>Urheberrecht</h5>{" "}
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
            diesen Seiten unterliegen dem deutschen Urheberrecht. Die
            Vervielf&auml;ltigung, Bearbeitung, Verbreitung und jede Art der
            Verwertung au&szlig;erhalb der Grenzen des Urheberrechtes
            bed&uuml;rfen der schriftlichen Zustimmung des jeweiligen Autors
            bzw. Erstellers. Downloads und Kopien dieser Seite sind nur f&uuml;r
            den privaten, nicht kommerziellen Gebrauch gestattet.
          </p>{" "}
          <p>
            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt
            wurden, werden die Urheberrechte Dritter beachtet. Insbesondere
            werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie
            trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten
            wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
            Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
          </p>
          <p>
            Quelle: <a href="https://www.e-recht24.de">e-recht24.de</a>
          </p>
        </Container>
      </SectionHelper>
    </>
  );
}

export default Impressum;
